import React, { useState } from 'react';
import './Deposit.scss';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSyncAlt, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../i18n';
import { Button, Alert } from 'react-bootstrap';
import { useTransactions } from '../../../hooks/useTransactions';
import { Input } from '../../Input';
import * as Config from "../../../config";
import { useAuth } from '../../../hooks/useAuth';
import { Link } from "react-router-dom";


export const Deposit = ({ modalIsVisible, setModalIsVisible, modalType = 'modal' }) => {
    const { register, errors, getValues, setValue, handleSubmit, reset } = useForm();
    const useTransaction = useTransactions();
    const [loading, setLoading] = useState(false);
    const [thankYou, setThankYou] = useState(false);
    const [errorAmount, setErrorAmount] = useState(false);
    const auth = useAuth();

    const closeModal = () => {
        setLoading(false);
        setThankYou(false);
        reset();
        setModalIsVisible(false);
    }
    window.addEventListener('keydown', (event) => {
        if (event.keyCode === 27) {
            closeModal();
        }
    });
    let methoodNum = 1;
    
    const methods = {
        'bank': {title: 'Bank Wire', id: 2}  //2
    };

    if (Config.PAYPOUND_KEY && Config.PAYPOUND_URL) {
        methods['paypound'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.NEOBANQ_KEY) {
        methods['neobanq'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.IKAJO_KEY && Config.IKAJO_URL) {
        methods['ikajo'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.CHARGE_MONEY_KEY && Config.CHARGE_MONEY_URL) {
        methods['chargeMoney'] = {title: Config.CHARGE_MONEY_LABEL ? Config.CHARGE_MONEY_LABEL : `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.PAYWAY_ID && Config.PAYWAY_KEY) {
        methods['PayWay'] = {title: `Visa`, id: 1};
    }

    if (Config.PAYMAXIS_ID && Config.PAYMAXIS_TOKEN && Config.PAYMAXIS_KEY) {
        methods['paymaxis'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.IPAYTOTAL_KEY) {
        methods['iPayTotal'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.CASHIER_KEY && Config.CASHIER_URL) {
        methods['cashier'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.CIDRUS_KEY && Config.CIDRUS_URL) {
        methods['cidrus'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.BITCOBROKERS_KEY && Config.BITCOBROKERS_URL) {
        methods['bitcobrokers'] = {title: 'Alternative', id: 3};
    }

    if (Config.VENUS_URL) {
        methods['venus'] = {title: 'Partner Exchange', id: 1};
    }

    if (Config.TITAN_URL) {
        methods['titan'] = {title: 'Titan Payments', id: 9};
    }

    if (Config.CASHONEX_URL && Config.CASHONEX_SALT && Config.CASHONEX_KEY) {
        methods['cashonex'] = {title: Config.CASHONEX_LABEL ? Config.CASHONEX_LABEL : `Credit Card ${methoodNum++}`, id: 1};
    }

    if (Config.NONSTOPAY_URL) {
        methods['nonstopay'] = {title: `Credit Card ${methoodNum++}`, id: 1};
    }

    const deposit = () => {
        setThankYou(false);
        setErrorAmount(false);
        const data = getValues();
        if (
            Number(data.amount) >= Number(Config.MINIMUM_DEPOSIT) &&
            (
            getValues().method === 'bank' ||
            Config.MAXIMUM_DEPOSIT === undefined ||
            Config.MAXIMUM_DEPOSIT === null ||
            Config.MAXIMUM_DEPOSIT === '' ||
            Number(data.amount) <= Number(Config.MAXIMUM_DEPOSIT)
            )
        ) {
            setLoading(true);
            useTransaction.create(data, setValue, setLoading, setThankYou, closeModal, methods);
        } else {
            setErrorAmount(true);
        }
    }
    const getDepositErrorMessage = () => {
        const data = getValues();
        const amount = Number(data.amount);
        const min = Number(Config.MINIMUM_DEPOSIT);
        const maxExists = Config.MAXIMUM_DEPOSIT !== undefined && Config.MAXIMUM_DEPOSIT !== null && Config.MAXIMUM_DEPOSIT !== '';
        const max = maxExists ? Number(Config.MAXIMUM_DEPOSIT) : null;

        if (isNaN(amount) || amount < min) {
            return i18n.t('platform.modal.error_minimum_deposit') + ` ${Config.CURRENCY_SYMBOL} ${Config.MINIMUM_DEPOSIT}`;
        }

        if (maxExists && amount > (max as number) && getValues().method !== 'bank') {
            return i18n.t('platform.modal.error_maximum_deposit') + ` ${Config.CURRENCY_SYMBOL} ${Config.MAXIMUM_DEPOSIT}`;
        }

        return '';
    };
    return (<>
        {modalIsVisible &&
            <>
                {modalType === 'modal' && <div className="deposit-bg" onClick={() => closeModal()}></div>}
                <div className={`deposit-${modalType}`}>
                    <div className="title">
                        {i18n.t('platform.modal.deposit')}
                        {modalType === 'modal' && <span onClick={() => closeModal()}><FontAwesomeIcon icon={faTimes} /></span>}
                    </div>
                    {!auth.missingDetails() &&
                        <form onSubmit={handleSubmit(deposit)}>

                            <ul>
                                {Object.keys(methods).map((item, i) => {
                                    return <li key={i}><label className="radioContainer">
                                        <input type="radio" name="method" value={item} ref={register({ required: true })} defaultChecked={(i === 0) ? true : false} />
                                        <span className="checkmark">{methods[item].title}</span>
                                    </label></li>
                                })}
                            </ul>
                            {!thankYou &&
                                <div className="wrapper-input" data-currency={Config.CURRENCY_SYMBOL}>
                                    <Input name="amount" type="number" reference={register({ required: true })} errors={errors} title={i18n.t('platform.modal.depositAmount.label')} placeholder={i18n.t('platform.modal.depositAmount.placeholder') + Config.MINIMUM_DEPOSIT} />
                                    <div className="error">{errorAmount && getDepositErrorMessage()}</div>
                                </div>
                            }
                            {loading && <FontAwesomeIcon icon={faSyncAlt} spin size="lg" className="spinner" />}
                            {thankYou &&
                                <div className="thankYou">
                                    <FontAwesomeIcon icon={faCheckCircle} size="lg" />
                                    {i18n.t('platform.modal.deposit_thank_you')}
                                </div>
                            }
                            <div className="footer">
                                {!thankYou &&
                                    <Button disabled={loading} type="submit">{i18n.t('platform.modal.deposit_button')}</Button>
                                }
                            </div>
                            <div id="cashier"></div>
                        </form>
                    }
                    {auth.missingDetails() &&
                        <>
                            <Alert variant="warning" className="text-center">
                                {i18n.t('platform.modal.depositMissingDetails')} <br />
                                <Link to="/my-account/info">Click here</Link>
                            </Alert>
                        </>
                    }
                </div>
            </>
        }
    </>);
}